<template>
    <b-modal
        class="apprentice-default-modal"
        v-model="modal"
        :title="$t('presentation.copy_presentation')"
        :ok-disabled="!name"
        :ok-title="$t('common.copy')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @keydown.native.enter="onEnter()">
        <div
            class="row"
            style="margin-bottom: 20px">
            <div class="col col-md-12">
                <label>{{ $t('common.name') }}</label>
                <b-form-input
                    v-model="name"
                    trim
                    type="text"
                    :placeholder="$t('presentation.fill_in_the_desired_name_here')" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-form-group>
                    <b-form-radio
                        v-model="chooseFolder"
                        name="existing-option"
                        :value="0">
                        {{ $t('presentation.place_in_current_folder') }}
                    </b-form-radio>
                    <b-form-radio
                        v-model="chooseFolder"
                        name="existing-option"
                        :value="1">
                        {{ $t('presentation.choose_folder') }}
                    </b-form-radio>
                </b-form-group>
            </div>
        </div>
        <div
            class="row"
            v-if="chooseFolder">
            <div class="col col-md-12">
                <label>{{ $t('presentation.choose_folder') }}</label>
                <design-2021-apprentice-tree-view-component
                    :data="topFoldersIn"
                    children="folders"
                    :indent="18"
                    :selected="selected">
                </design-2021-apprentice-tree-view-component>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { CommonBus } from '../../../app';
import Design2021ApprenticeTreeViewComponent from '../../common/TreeView/design-2021-apprentice-tree-view-component';

export default {
    name: 'design-2021-copy-presentation-modal',
    components: { Design2021ApprenticeTreeViewComponent },
    props: {
        currentFolderIdIn: {
            type: Number
        },
        topFoldersIn: {
            type: Array
        }
    },
    data() {
        return {
            chooseFolder: 0,
            modal: false,
            name: null,
            selected: null,
            selectedFolders: []
        };
    },
    methods: {
        show(presentation) {
            this.presentation = presentation;
            this.name = presentation.name + ' (' + this.$t('common.copy') + ')';
            this.modal = true;
        },
        onEnter() {
            this.modal = false;
            this.onOk();
        },
        onOk() {
            let selected_folder_id = this.currentFolderIdIn;

            if (this.chooseFolder) {
                selected_folder_id = this.selected.id;
            }

            let data = {
                id: this.presentation.id,
                name: this.name,
                folder_id: selected_folder_id
            };

            this.axios.post(this.routes.presentationCopy(this.presentation.id), data).then(
                (response) => {
                    this.$emit('data-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                }
            );
        }
    },
    created() {
        CommonBus.$on('tree-view-selected-item', (item) => {
            this.selected = item;
        });
    }
};
</script>

<style scoped lang="scss"></style>
